export default () => {
  const { search } = window.location;
  const query = new URLSearchParams(search);

  const queryArray = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const param of query.entries()) {
    queryArray.push(...param);
  }
  return queryArray;
};
